import React from 'react';
import moment from 'moment';
import { useHistory, useParams } from 'react-router';
import { useMutation, useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { message } from 'antd';
import ProjectHeader from '../../ProjectHeader';
import {
  UPDATE_SCHEDULED_REPORT_SUBMISSION,
  GET_REPORT_SUBMISSIONS,
} from '../../../../gql/reportSubmissions';
import ReportSubmissionScheduleForm from '../components/ReportSubmissionScheduleForm';
// import ProposalRevisionSteps from '../components/ProposalRevisionSteps';

const EditReportSubmission = () => {
  const { projectId, id } = useParams();
  const history = useHistory();
  const [editReportSubmission] = useMutation(
    UPDATE_SCHEDULED_REPORT_SUBMISSION,
    {
      refetchQueries: [
        {
          query: GET_REPORT_SUBMISSIONS,
          variables: {
            projectIds: [projectId],
            ids: [id],
          },
        },
      ],
      onCompleted: () => {
        message.success(`Report Submission Schedule saved`);
        history.push(`/projects/${projectId}/report-submissions`);
      },
    }
  );
  const { data, loading } = useQuery(GET_REPORT_SUBMISSIONS, {
    variables: {
      projectIds: [projectId],
      ids: [id],
    },
  });
  const onFinish = async ({
    reportType,
    scheduledSubmissionDate,
    reportingPeriod,
  }) => {
    await editReportSubmission({
      variables: {
        input: {
          id,
          projectId,
          reportType,
          scheduledSubmissionDate: moment(scheduledSubmissionDate).format(
            'YYYY-MM-DD'
          ),
          reportingPeriod,
        },
      },
    });
  };
  const reportSubmission = data?.reportSubmissions[0];
  const initialValues = reportSubmission
    ? {
        reportType: reportSubmission.reportType,
        scheduledSubmissionDate: reportSubmission.scheduledSubmissionDate,
        reportingPeriod: reportSubmission.reportingPeriod,
      }
    : {};

  return (
    <ProjectHeader>
      <PageContainer
        header={{ title: 'Edit Report Submission Schedule' }}
        ghost
        loading={loading}
        style={{ marginBottom: '32px' }}
      >
        {/* <ProposalRevisionSteps current={0} /> */}
        <ReportSubmissionScheduleForm
          onFinish={onFinish}
          initialValues={initialValues}
        />
      </PageContainer>
    </ProjectHeader>
  );
};

export default EditReportSubmission;
